var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/original_product_logo.de95c1fb.png","uri@2x": __webpack_public_path__ + "static/media/original_product_logo.e79ddc0c.png","uri@3x": __webpack_public_path__ + "static/media/original_product_logo.1f988f9a.png",
    width: 16,
    height: 17
});